export type BatteryIconLevel = 'Full' | 'AlmostFull' | 'MidCharge' | 'Low'

export function getBatteryIconLevel(stateOfCharge: number): BatteryIconLevel {
  /* Clamp out-of-range values to the nearest valid level. */
  if (stateOfCharge >= 1) return 'Full'
  if (stateOfCharge >= 0.9) return 'AlmostFull'
  if (stateOfCharge >= 0.3) return 'MidCharge'
  return 'Low'
}
